var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1668 1.5C18.3688 2.0629 17.4853 2.49343 16.5502 2.775C16.0483 2.19793 15.3813 1.78891 14.6394 1.60327C13.8974 1.41764 13.1164 1.46433 12.4019 1.73705C11.6874 2.00976 11.0739 2.49534 10.6443 3.1281C10.2148 3.76086 9.98991 4.51028 10.0002 5.275V6.10834C8.53569 6.14631 7.08456 5.82151 5.776 5.16287C4.46745 4.50424 3.34209 3.5322 2.50016 2.33334C2.50016 2.33334 -0.833171 9.83334 6.66683 13.1667C4.9506 14.3316 2.90613 14.9158 0.833496 14.8333C8.3335 19 17.5002 14.8333 17.5002 5.25C17.4994 5.01788 17.4771 4.78633 17.4335 4.55834C18.284 3.71958 18.8842 2.6606 19.1668 1.5V1.5Z",
    stroke: "#97A0AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.95c72f23c5a37b885f4f60b9ee6e1d44.svg";
export { ForwardRef as ReactComponent };